import {
  GET_EMPLOYEE_LIST,
  GET_EMPLOYEE_BY_ID,
  RESET_EMPLOYEE,
  GET_EMPLOYEE_DOCS,
  GET_EMPLOYEE_DOCS_DETAILS,
  EMPLOYEE_SEARCH,
  EMPLOYEE_COUNTRY_LIST,
  EMPLOYEE_BIRTH_PASSPORT_GRADUATION_COUNTRY_LIST,
  GET_ALL_REQUEST_TYPES,
  GET_ALL_EMPLOYEE_REQUESTS,
  GET_ALL_ACTIVE_EMPLOYEES,
  GET_EMPLOYEE_TOTALS,
  GET_ALL_REQUESTS_OPTIONS,
  GET_ALL_EMPLOYEE_VACATION,
  GET_ALL_EMPLOYEE_VACATION_LIST,
  GET_ALL_EMPLOYEE_VACATION_LIST_FOR_SET,
  GET_EMPLOYEES_WITH_LIBRARY_SUMMARY,
  GET_EMPLOYEE_CLASSES,
  GET_EMPLOYEE_LIBRARY_SUMMARY,
  GET_EMPLOYEE_BOOKS_SUMMARY,
  GET_EMPLOYEE_STORY_SUMMARY,
  GET_EMPLOYEE_NOT_RETURNED_BOOKS,
  GET_COMPREHENSIVE_REPORTS,
  GET_EMPLOYEE_APPLICATIONS,
  GET_LOGIN_HISTORY,
  GET_DB_HISTORY,
  ADD_EMPLOYEE_LOG,
  GET_DEPARTMENT_REPORT
  
} from "../constants/EmployeeArea";

import axiosinstance from "../../auth/AxiosIntance";
import axios from "axios";

const cancelTokens = {};
export function importEmp(req) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post("admin/employee/import", req);
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function getEmployees(queryParams) {
  return async (dispatch) => {
    // Cancel previous request if it exists
    if(cancelTokens['getEmployees']){
      cancelTokens['getEmployees'].cancel('New request initiated');
    }
    // Create new cancel token for this request
    cancelTokens['getEmployees'] = axios.CancelToken.source();
    
    try {
      var response = await axiosinstance.get("admin/employee/get-all", {
        params: queryParams,
        cancelToken: cancelTokens['getEmployees'].token,
      });
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_LIST,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      // Ignore cancel errors - they're intentional when a new request is made
      if (axios.isCancel(e)) {
        // Request was intentionally cancelled, return a cancelled response
        return Promise.resolve({ status: false, message: 'Request cancelled', cancelled: true });
      }
      console.log("catch error API GET_EMPLOYEE_LIST", e);
      return Promise.reject(e);
    }
  };
}

// export function addEmployees(req) {
//     return async dispatch => {
//         try {
//             var response = await axiosinstance.post('admin/employee/update', req)
//             var responseJson = response.data;
//             if (!responseJson.status) {
//                 return Promise.reject(responseJson);
//             } else {

//                 return Promise.resolve(responseJson);
//             }
//         }
//         catch (e) {
//             console.log("err", e);
//             return Promise.reject(e);
//         }
//     }
// }

export function getEmployeeById(id) {
  return async (dispatch) => {
    dispatch({
      type: RESET_EMPLOYEE,
      payload: "Reset Employee",
    });
    try {
      var response = await axiosinstance.get("admin/employee/get-by-id/" + id);
      var responseJson = response.data;
      if (!responseJson.status) {
        dispatch({
          type: GET_EMPLOYEE_BY_ID,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      } else {
        responseJson.data.birth_place = parseInt(responseJson.data.birth_place);
        dispatch({
          type: GET_EMPLOYEE_BY_ID,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("catch error API GET_EMPLOYEE_BY_ID", e);
      return Promise.reject(e);
    }
  };
}

export function changeEmployeeLanguage(language) {
  return async () => {
    try {
      const response = await axiosinstance.post("/admin/employee/change-language", {
        language,
      });
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      }
      return Promise.resolve(responseJson);
    } catch (e) {
      console.log("err changeEmployeeLanguage", e);
      return Promise.reject(e?.response?.data || e);
    }
  };
}

export function changeEmployeePassword({ oldPassword, newPassword }) {
  return async () => {
    try {
      const response = await axiosinstance.post("/admin/employee/change-password", {
        old_password: oldPassword,
        new_password: newPassword,
      });
      return Promise.resolve(response.data);
    } catch (e) {
      if (e?.response?.status === 401) {
        return Promise.resolve(
          e.response?.data || {
            status: false,
            msg: "Unauthorized, please log in to continue",
          }
        );
      }
      console.log("err changeEmployeePassword", e);
      return Promise.reject(e?.response?.data || e);
    }
  };
}

export function updateEmployee(req) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post("admin/employee/update", req);
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function deleteEmployee(id) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.delete("admin/employee/" + id);
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeDocs(queryData) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get("admin/employeedocument/get-all", {
        params: queryData,
      });
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_DOCS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("Catch err getEmployeeDocs = ", e);
      return Promise.reject(e);
    }
  };
}

export function uploadEmployeeDocument(data) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post(
        "admin/employeedocument/add",
        data
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("Catch err uploadEmployeeDocument = ", e);
      return Promise.reject(e);
    }
  };
}

export function deleteEmployeeDocument(id) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.delete("admin/employeedocument/" + id);
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("Catch err deleteEmployeeDocument = ", e);
      return Promise.reject(e);
    }
  };
}

export function updateEmployeeDocument(data) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post(
        "admin/employeedocument/update",
        data
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("Catch err updateEmployeeDocument = ", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeDocumentDetails(id) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        "admin/employeedocument/get-by-id/" + id
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_DOCS_DETAILS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("Catch err getEmployeeDocumentDetails = ", e);
      return Promise.reject(e);
    }
  };
}

export function uploadEmployee_ProfileImage(data) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post(
        "admin/employee/update-profile",
        data
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("Catch err uploadStudent_ProfileImage = ", e);
      return Promise.reject(e);
    }
  };
}

export function setEmployeeSearch(queryParams) {
  return async (dispatch) => {
    try {
      dispatch({
        type: EMPLOYEE_SEARCH,
        payload: queryParams,
      });
      return Promise.resolve(queryParams);
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function setEmployeeListSearch(queryParams) {
  return async (dispatch) => {
    try {
      dispatch({
        type: EMPLOYEE_SEARCH,
        payload: queryParams,
      });
      return Promise.resolve(queryParams);
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeesCountryList() {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        "admin/get-empCountry/get-empCountry"
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: EMPLOYEE_COUNTRY_LIST,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("catch error API GET_EMPLOYEE_LIST", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeesB_P_G_CountryList() {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        "admin/get-empCountry/get-empBirthPlace"
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: EMPLOYEE_BIRTH_PASSPORT_GRADUATION_COUNTRY_LIST,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("catch error API GET_EMPLOYEE_LIST", e);
      return Promise.reject(e);
    }
  };
}

export function getListEmployees() {
  return async () => {
    try {
      var response = await axiosinstance.get(
        "/admin/manage-employees/get_employees_List?department_id=&is_academic=&position_id=&group_id=&employee_id=&employee_full_name=&order_by=full_name&sort_order=ASC&size=300000"
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getSearchedEmployeesData(params) {
  return async () => {
    try {
      var response = await axiosinstance.get(
        "/admin/manage-employees/get_employees_List",
        { params }
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

//   for emplyee groups
export function lockEmployeeAccount(req) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        "/admin/manage-employees/set_employee_login_status",
        req
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function setEmployeePassword(req) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        "/admin/manage-employees/set_employee_login_password",
        req
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function assignEmployeeGroup(req) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        "/admin/manage-employees/set_employee_groups",
        req
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getOneEmployeeById(id) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        `/admin/manage-employees/get_employee/${id}`
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function lockBulckEmployeeAccount(req) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        "/admin/manage-employees/bulk_set_employees_status",
        req
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function setBulckEmployeePassword(req) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        "/admin/manage-employees/bulk_set_employees_password",
        req
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function assignBulckEmployeeGroup(req) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        "/admin/manage-employees/bulk_set_employees_groups",
        req
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getAllEmployeesRequests(
  page,
  size,
  request_type_ids = '',
  dates = [],
  employee_ids = '',
  request_type = '',
  status = '',
  academic_year_id = '',
  employee_request_option_id  = '',
  applying_regulation_option = '',
  penality_status = ''
) {
  return async (dispatch) => {
    let start_date = dates ? dates[0]?.toISOString()?.split("T")[0] : "";
    let end_date = dates ? dates[1]?.toISOString()?.split("T")[0] : "";
    const params = {
      page,
      size,
      request_type_ids,
      employee_ids,
      start_date,
      end_date,
      request_type,
      status,
      academic_year_id,
      employee_request_option_id,
      applying_regulation_option,
      penality_status
    }
    try {
      var response = await axiosinstance.get(`/admin/employee/request-form`, { params });
      var responseJson = response.data;
      if (!responseJson.status) {
        dispatch({
          type: GET_ALL_EMPLOYEE_REQUESTS,
          payload: [],
        });
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_EMPLOYEE_REQUESTS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function getEmployeesRequests(params) {
  return async () => {
    try {
      var response = await axiosinstance.get(`/admin/employee/request-form`, { params });
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getAllEmployeesRequestsById(id) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        `/admin/employee/request-form/${id}`
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getAllRequestTypes(type) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        `/admin/employee/request-form/types?type=${type}`
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_REQUEST_TYPES,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function createEmployeeRequest(values) {
  return async () => {
    try {
      var response = await axiosinstance.post(
        `/admin/employee/request-form/update`,
        values
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getAllActiveEmployees(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(`/shared/employee`, {params});
      var responseJson = response.data;

      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_ACTIVE_EMPLOYEES,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}


export function deleteRequests(values) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.delete(
        `/admin/employee/request-form`,
        {
          data: values,
        }
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeTotals(
  employee_ids,
  request_type_ids,
  dates,
  request_type
) {
  let start_date = dates ? dates[0]?.toISOString()?.split("T")[0] : "";
  let end_date = dates ? dates[1]?.toISOString()?.split("T")[0] : "";
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        `/admin/employee/request-form/total?employee_ids=${
          employee_ids ?? ""
        }&request_type_ids=${
          request_type_ids ?? ""
        }&start_date=${start_date}&end_date=${end_date}&request_type=${request_type ?? ''}`
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_TOTALS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getALLRequestsOptions(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        `/admin/employee/request-form/options`, {params}
      );
      var responseJson = response.data;

      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_REQUESTS_OPTIONS,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function changeEmployeeRequestStatus(queryParams) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post(
        `/admin/employee/request-form/status`,
        queryParams
      );
      var responseJson = response.data;

      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeesWithLibrarySummary(queryParams) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        `/admin/employee/borrowed-books?teacher_id=${
          queryParams?.teacher_id ?? ""
        }&school_grade_id=${queryParams?.school_grade_id ?? ""}&teacher_name=${
          queryParams?.name ?? ""
        }&school_class_id=${
          queryParams?.school_class_id ?? ""
        }&library_section_id=${
          queryParams?.library_section_id ?? ""
        }&library_book_id=${
          queryParams?.library_book_id ?? ""
        }&return_start_date=${
          queryParams?.return_start_date ?? ""
        }&return_end_date=${queryParams?.return_end_date ?? ""}&status=${
          queryParams?.status ?? ""
        }`
      );
      var responseJson = response.data;

      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEES_WITH_LIBRARY_SUMMARY,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function employeeBorrowBook(data) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post(
        "/admin/employee/borrowed-books",
        data
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function setEmployeeActualVacations(data) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.post(
        "/admin/employee_vacation/set_employee_actual_vacations",
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getAllEmployeeVacationsConfig() {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get("/admin/employee_vacation");
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_EMPLOYEE_VACATION,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeesWithVacationsList(params) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get(
        "/admin/employee_vacation/employee_vacations_list",
        { params }
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_EMPLOYEE_VACATION_LIST,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeesWithVacationsListForSet(params) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get(
        "/admin/employee_vacation/employee_vacations_list_for_set",
        { params }
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_ALL_EMPLOYEE_VACATION_LIST_FOR_SET,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function createEmployeeVacationConfig(data) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.post(
        "/admin/employee_vacation",
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getTeachersClasses(teacher_id) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get(
        `/admin/school-system/students_subject_teachers/employee_classes_by_id/${teacher_id}`
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        dispatch({
          type: GET_EMPLOYEE_CLASSES,
          payload: null,
        });
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_CLASSES,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function teacherBorrowBook(data) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.post(
        "/admin/employee/borrowed-books",
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeLibrarySummary(queryParams) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get(
        `/admin/employee/borrowed-books/summary/${
          queryParams?.teacher_id ?? ""
        }?page=${queryParams?.page ?? 1}&size=${queryParams?.size ?? 30000}`
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_LIBRARY_SUMMARY,
          payload: responseJson.data,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeBooksSummary(queryParams) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get(
        `admin/employee/borrowed-books/books-summary/${
          queryParams?.teacher_id ?? ""
        }?page=${queryParams?.page ?? 1}&size=${queryParams?.size ?? 30000}`
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_BOOKS_SUMMARY,
          payload: responseJson.data?.TeachersBorrowedBooks,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeStorySummary(queryParams) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.get(
        `/admin/employee/borrowed-books/stories-summary/${
          queryParams?.teacher_id ?? ""
        }?page=${queryParams?.page ?? 1}&size=${queryParams?.size ?? 30000}`
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_STORY_SUMMARY,
          payload: responseJson.data?.TeachersBorrowedStories,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function deleteEmployeeBorrowRequest(ids) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.delete(
        `/admin/employee/borrowed-books`,
        { data: ids }
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function updateEmployeeBorrowStatus(data) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.post(
        `/admin/employee/borrowed-books/status`,
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function updateEmployeeBorrowRequest(id, data) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.post(
        `/admin/employee/borrowed-books/${id}`,
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}

export function getEmployeeNotReturnedBooks(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(
        `/admin/employee/borrowed-books/borrowed-books-un-returned`,
        {params}
      );
      var responseJson = response.data;
      if (!responseJson.status) {
        dispatch({
          type: GET_EMPLOYEE_NOT_RETURNED_BOOKS,
          payload: { data: [] },
        });
        return Promise.reject(responseJson);
      } else {
        dispatch({
          type: GET_EMPLOYEE_NOT_RETURNED_BOOKS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("catch error API GET_EMPLOYEE_LIST", e);
      return Promise.reject(e);
    }
  };
}

export function sendEmployeeLibraryReminder(data) {
  return async (dispatch) => {
    try {
      const response = await axiosinstance.post(
        `/admin/employee/borrowed-books/send-reminder-email-to-employees`,
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function returnBooks(data) {
  return async () => {
    try {
      const response = await axiosinstance.post(
        `/admin/employee/borrowed-books/return-books`,
        data
      );
      const responseJson = response.data;
      if (!responseJson.status) {
        return Promise.reject(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    } catch (e) {
      console.log("err", e);
      return Promise.reject(e);
    }
  };
}
export function getComprehensiveReport(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get('/admin/employee/report/getEmployeeReport', {params});
      var responseJson = response.data;
      if (responseJson.status) {
        dispatch({
          type: GET_COMPREHENSIVE_REPORTS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: GET_COMPREHENSIVE_REPORTS,
          payload: { data: [] },
        });
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API getStoreCategories", e);
      return Promise.reject(e);
    }
  }
}

export function createEmployeeApplication(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/employee-application/update', params);
      var responseJson = response.data;
      if (responseJson.status) {
        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API createEmployeeApplication", e);
      return Promise.reject(e);
    }
  }
}

export function getEmployeeApplicationById(id) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get(`/admin/employee-application/get-by-id/${id}`);
      var responseJson = response.data;
      if (responseJson.status) {
        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API GET_EMPLOYEE_APPLICATIONS", e);
      return Promise.reject(e);
    }
  }
}

export function getAllEmployeeApplications(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get('admin/employee-application/get-all', {params});
      var responseJson = response.data;
      if (responseJson.status) {
        dispatch({
          type: GET_EMPLOYEE_APPLICATIONS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API GET_EMPLOYEE_APPLICATIONS", e);
      return Promise.reject(e);
    }
  }
}

export function confirmEmployeeApplication(id) {
  return async () => {
    try {
      var response = await axiosinstance.post(`/admin/employee-application/confirm/${id}`);
      var responseJson = response.data;
      if (responseJson.status) {
        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API confirmEmployeeApplication", e);
      return Promise.reject(e);
    }
  }
}
export function deleteEmployeeApplication(id) {
  return async () => {
    try {
      var response = await axiosinstance.post(`/admin/employee-application/${id}`);
      var responseJson = response.data;
      if (responseJson.status) {
        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API deleteEmployeeApplication", e);
      return Promise.reject(e);
    }
  }
}
export function getLoginHistory(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get('/admin/employee/get-all-employee-login-history', {params});
      var responseJson = response.data;
      if (responseJson.status) {
        dispatch({
          type: GET_LOGIN_HISTORY,
          payload: responseJson,
        });        return Promise.resolve(responseJson);
      } else {
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API getLoginHistory", e);
      return Promise.reject(e);
    }
  }
}
export function getDbHistory(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get('/admin/changelog', {params});
      var responseJson = response.data;
      if (responseJson.status) {
        dispatch({
          type: GET_DB_HISTORY,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: GET_DB_HISTORY,
          payload: [],
        });
        return Promise.resolve(responseJson);
      }
    }
    catch (e) {
      console.log("catch error API getLoginHistory", e);
      return Promise.reject(e);
    }
  }
}

export function updateEmployeetLog(params) {
  console.log(params)
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/employee/log-employee-updates', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getLoginHistory", e);
      return Promise.reject(e);
    }
  }
}

export function getEmployeeLogs(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get('/admin/employee/logged-employee-updates', {params});
      var responseJson = response.data;
      if (responseJson.status) {
        dispatch({
          type: ADD_EMPLOYEE_LOG,
          payload: responseJson,
        });
      }else {
        dispatch({
          type: ADD_EMPLOYEE_LOG,
          payload: {},
        });
      }
      return Promise.resolve(responseJson);

    }
    catch (e) {
      console.log("catch error API getLoginHistory", e);
      return Promise.reject(e);
    }
  }
}
export function getdepartmetReport(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.get('/admin/emp_dynamic_report/department-reports', {params});
      var responseJson = response.data;
      if (responseJson.status) {
        dispatch({
          type: GET_DEPARTMENT_REPORT,
          payload: responseJson,
        });
      }else {
        dispatch({
          type: GET_DEPARTMENT_REPORT,
          payload: {},
        });
      }
      return Promise.resolve(responseJson);

    }
    catch (e) {
      console.log("catch error API getLoginHistory", e);
      return Promise.reject(e);
    }
  }
}

export function convertRequest(params) {
  return async (dispatch) => {
    try {
      var response = await axiosinstance.post('/admin/employee-fingerprint/change-absence-type', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API convertRequest", e);
      return Promise.reject(e);
    }
  }
}
export function convertLateRequestToLeave(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/employee/convert-to-leave', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API convertRequest", e);
      return Promise.reject(e);
    }
  }
}
export function getManagers(params) {
  return async () => {
    try {
      var response = await axiosinstance.get('/admin/employee/manager', { params });
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getManagers", e);
      return Promise.reject(e);
    }
  }
}

export function updateManager(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/employee/manager', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API updateManager", e);
      return Promise.reject(e);
    }
  }
}
export function getEmlpoyeeCourses(params) {
  return async () => {
    try {
      var response = await axiosinstance.get('/admin/employee/employee-courses', { params });
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getEmlpoyeeCourses", e);
      return Promise.reject(e);
    }
  }
}

export function createOrUpdateEmlpoyeeCourses(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/employee/employee-courses', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getEmlpoyeeCourses", e);
      return Promise.reject(e);
    }
  }
}

export function getEmlpoyeeVolunteer(params) {
  return async () => {
    try {
      var response = await axiosinstance.get('/admin/employee/employee-volunteers', { params });
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getEmlpoyeeVolunteer", e);
      return Promise.reject(e);
    }
  }
}

export function createOrUpdateEmlpoyeeVolunteer(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/employee/employee-volunteers', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API createOrUpdateEmlpoyeeVolunteer", e);
      return Promise.reject(e);
    }
  }
}
export function  deleteEmlpoyeeVolunteer(id) {
  return async () => {
    try {
      var response = await axiosinstance.delete(`/admin/employee/employee-volunteers/${id}`);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API deleteEmlpoyeeVolunteer", e);
      return Promise.reject(e);
    }
  }
}
export function getEmlpoyeeVolunteerReport(params) {
  return async () => {
    try {
      var response = await axiosinstance.get('/admin/employee/employee-volunteers/report', { params });
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getEmlpoyeeCourses", e);
      return Promise.reject(e);
    }
  }
}
export function  deleteEmlpoyeeCourses(id) {
  return async () => {
    try {
      var response = await axiosinstance.delete(`/admin/employee/employee-courses/${id}`);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API deleteEmlpoyeeCourses", e);
      return Promise.reject(e);
    }
  }
}

export function getEmlpoyeeCoursesReport(params) {
  return async () => {
    try {
      var response = await axiosinstance.get('/admin/employee/employee-courses/report', { params });
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getEmlpoyeeCourses", e);
      return Promise.reject(e);
    }
  }
}

export function sendEmployeeSms(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/lms-roles/notifications_sms/send-employee-sms', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API sendEmployeeSms", e);
      return Promise.reject(e);
    }
  }
}

export function sendClientSms(params) {
  return async () => {
    try {
      var response = await axiosinstance.post('/admin/lms-roles/notifications_sms/send-client-sms', params);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API sendEmployeeSms", e);
      return Promise.reject(e);
    }
  }
}

export function getClientSms(id) {
  return async () => {
    try {
      var response = await axiosinstance.get(`/admin/lms-roles/notifications_sms/${id}`);
      var responseJson = response.data;
      return Promise.resolve(responseJson);
    }
    catch (e) {
      console.log("catch error API getClientSms", e);
      return Promise.reject(e);
    }
  }
}

export function getMyContractRenewal(params) {
  return async () => {
    try {
      const response = await axiosinstance.get(
        "/admin/employee/contract-renewal/my",
        { params }
      );
      return Promise.resolve(response.data);
    } catch (e) {
      console.log("catch error API getMyContractRenewal", e);
      return Promise.reject(e);
    }
  };
}

export function submitContractRenewal(body) {
  return async () => {
    try {
      const response = await axiosinstance.post(
        "/admin/employee/contract-renewal",
        body
      );
      return Promise.resolve(response.data);
    } catch (e) {
      console.log("catch error API submitContractRenewal", e);
      return Promise.reject(e);
    }
  };
}

export function getContractRenewalList(params) {
  return async () => {
    try {
      const response = await axiosinstance.get(
        "/admin/employee/contract-renewal",
        { params }
      );
      return Promise.resolve(response.data);
    } catch (e) {
      console.log("catch error API getContractRenewalList", e);
      return Promise.reject(e);
    }
  };
}

export function respondContractRenewal(body) {
  return async () => {
    try {
      const response = await axiosinstance.post(
        "/admin/employee/contract-renewal/respond",
        body
      );
      return Promise.resolve(response.data);
    } catch (e) {
      console.log("catch error API respondContractRenewal", e);
      return Promise.reject(e);
    }
  };
}
